import { render } from "./Zona.vue?vue&type=template&id=1ed16398"
import script from "./Zona.vue?vue&type=script&lang=js"
export * from "./Zona.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__